<template>
  <div class="p-4">
    <div class="row justify-content-md-center">
      <div class="col-lg-8 col-md-10 col-12">
        <div class="card">
          <div class="card-header">
            <h4>My profile</h4>
          </div>
          <div class="card-body">
            <form v-on:submit.prevent="fnUpdateUserProfile">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-12">
                  <div class="form-group">
                    <label for="firstName">First name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="firstName"
                      placeholder="First name"
                      v-model="userData.firstName"
                    />
                    <div class="invalid-feedback" v-if="errors.firstName">
                      {{ errors.firstName[0] }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="lastName">Last name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="lastName"
                      placeholder="Last name"
                      v-model="userData.lastName"
                    />
                    <div class="invalid-feedback" v-if="errors.lastName">
                      {{ errors.lastName[0] }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="email">Email</label>
                    <input
                      type="email"
                      class="form-control"
                      id="email"
                      placeholder="Email"
                      disabled
                      v-model="userData.email"
                    />
                    <div class="invalid-feedback" v-if="errors.email">
                      {{ errors.email[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-12">
                  <div class="form-group">
                    <label for="middleName">Middle name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="middleName"
                      placeholder="Middle name"
                      v-model="userData.middleName"
                    />
                  </div>
                  <div class="form-group">
                    <label for="role">Role</label>
                    <b-form-select
                      plain
                      :options="roleOptions"
                      value-field="id"
                      text-field="text"
                      placeholder=" "
                      autocomplete="off_role"
                      disabled
                      v-model="userData.role_id"
                    ></b-form-select>
                  </div>
                  <div class="form-group mt-3">
                    <label for="imageUpload">Profile image upload</label>
                    <div class="avatar-upload">
                      <div class="avatar-edit">
                        <input
                          ref="doc"
                          type="file"
                          id="imageUpload"
                          accept=".png, .jpg, .jpeg"
                          @change="onFileSelected($event)"
                        />
                        <label for="imageUpload"></label>
                      </div>
                      <div class="avatar-preview">
                        <div
                          v-if="userData.profileImage"
                          id="imagePreview"
                          v-bind:style="{
                            backgroundImage:
                              'url(' + userData.profileImage + ')'
                          }"
                        ></div>
                        <div v-else id="imagePreview">
                          <i class="las la-user-alt fs-12000 text-primary"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-right">
                <button
                  type="button"
                  class="btn btn-dark btn-sm mr-2"
                  @click="fnCancel()"
                >
                  Cancel
                </button>
                <button type="submit" class="btn btn-primary btn-sm">
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import * as messageService from '../../../services/message.service'
import * as authService from '../../../services/auth.service'
export default {
  name: 'profileUpdate',
  components: {},
  data() {
    return {
      errors: {},
      userData: {
        id: '',
        firstName: '',
        middleName: '',
        lastName: '',
        email: '',
        profileImage: '',
        role_id: ''
      },
      roleOptions: [
        { id: 1, text: 'Admin' },
        { id: 2, text: 'VSA staff' },
        { id: 4, text: 'Dealer staff' },
        { id: 5, text: 'Referral partner' }
      ],
      selectedFile: null
    }
  },
  computed: {
    ...mapGetters(['getUserProfile'])
  },
  methods: {
    fnUpdateUserProfile: async function () {
      let formData = new FormData()
      formData.append('firstName', this.userData.firstName)
      formData.append('middleName', this.userData.middleName)
      formData.append('lastName', this.userData.lastName)
      formData.append('email', this.userData.email)
      formData.append('image', this.selectedFile)

      try {
        const response = await authService.profileUpdate(formData)
        messageService.fnSweetAlertSuccessToast(
          'Profile',
          'Updated successfully'
        )

        this.$router.push({ name: 'auth.sign-in' })

        this.userData = {
          id: '',
          firstName: '',
          middleName: '',
          lastName: '',
          email: '',
          profileImage: '',
          role_id: ''
        }
      } catch (error) {
        switch (error.response.status) {
          case 401:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Profile update',
              error.response.data.message
            )
            break
          case 422:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Profile update',
              error.response.data.message
            )
            break
          case 500:
            messageService.fnSweetAlertErrorToast(
              'Profile update',
              error.response.data.message
            )
            break
          default:
            messageService.fnSweetAlertErrorToast(
              'Profile update',
              'Something wrong, please try again!'
            )
            break
        }
      }
    },
    fnCancel() {
      if (this.userData.role_id == 1 || this.userData.role_id == 2) {
        this.$router.push({ name: 'admin.dashboard' })
      } else if (this.userData.role_id == 3) {
        this.$router.push({ name: 'dealerManager.dashboard' })
      } else if (this.userData.role_id == 4) {
        this.$router.push({ name: 'dealer.dashboard' })
      } else if (this.userData.role_id == 5) {
        this.$router.push({ name: 'referralPartner.dashboard' })
      } else {
        this.$router.push({ name: 'auth.sign-in' })
      }
    },
    onFileSelected(event) {
      const selectedFile = event.target.files
      this.selectedFile = event.target.files[0]
      if (!selectedFile.length) return

      const reader = new FileReader()
      reader.readAsDataURL(selectedFile[0])
      reader.onload = () => (this.userData.profileImage = reader.result)
    }
  },
  watch: {},
  created() {
    this.userData = authService.getUserFromToken()
  }
}
</script>
